import React from "react";
import ReactApexChart from "react-apexcharts";

function GraphView({ lineChartOptions, chartData }) {
  return (
    <div className="h-[80dvh] md:h-[100dvh]">
      <ReactApexChart
        options={lineChartOptions}
        series={chartData?.chartData || []}
        type="area"
        width="100%"
        height={"100%"}
      />
    </div>
  );
}

export default GraphView;
